import React from 'react';
import {Outlet} from 'react-router-dom';
import {isFinance} from 'shared/lib/isFinance';
import {AppLogo} from 'ui';
import styles from './UnAuthorizedLayout.module.css';

export function UnAuthorizedLayout(): React.ReactElement {
	const vendor = isFinance() ? 'Рокет Ворк Финанс' : 'Рокет Ворк';
	const copyright = `© ${vendor} ${new Date().getFullYear()}`;

	return (
		<div className={styles.root}>
			<header className={styles.header}>
				<div className={styles.logoWrap}>
					<AppLogo to="/auth/login" />
				</div>
				<div className={styles.headerSupport}>
					<div className={styles.flagOrb} aria-hidden="true" />
					<span className={styles.supportLabel}>Поддержка</span>
				</div>
			</header>

			<div className={styles.supportRibbonWrap}>
				<div className={styles.supportRibbon}>Поддержка</div>
			</div>

			<main className={styles.main}>
				<Outlet />
			</main>
			<footer className={styles.footer}>
				<p className={styles.copyright}>{copyright}</p>
			</footer>
		</div>
	);
}
